module["exports"] = [
  "#{Address.state} #{creature}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/team/name.js
 ** module id = 553
 ** module chunks = 0
 **/